<template>
  <nav>
    <ul class="nav-list">
      <li class="logo">
        <a href="index.html"
          ><img
            src="@/images/logo.png"
            alt="Reeracoen Freelance Recruiting Business"
        /></a>
      </li>
      <li class="btn-group">
        <ul class="list">
          <div class="phone">
            <a class="link icon-link" href="tel:+6602-253-9800"
              ><i class="las la-phone-volume"></i
              ><span class="phone-num">(+66) 02-253-9800</span
              ><span class="call-us">Call us</span></a
            >
          </div>
          <li class="register-button">
            <a class="btn btn-blue" href="#">Contact Us</a>
          </li>
        </ul>
      </li>
    </ul>
  </nav>
</template>
<script>
export default {
  name: "NavClient",
};
</script>
<style scoped lang="scss">
@import "@/assets/stylesheets/application";
nav {
  .nav-list {
    align-items: center;
    background: transparent;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;
    padding: 1.5rem 2rem;

    .logo {
      img {
        width: 200px;
      }
    }

    .btn-group {
      .list {
        align-items: center;
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        justify-content: center;
        line-height: 0;
        padding: 0;

        & > * {
          padding: 0 1rem;

          .btn {
            width: 120px;
          }
        }

        .phone {
          .link {
            color: $blue-primary;
            font-size: 1em;
            font-weight: 700;
            display: flex;
            align-items: center;
          }

          i {
            font-size: 20px;
            margin-right: 8px;
          }
          .phone-num {
            display: block;
          }
          .call-us {
            display: none;
          }
        }
      }
    }
  }
}
@media only screen and (max-width: 991px) {
  nav {
    .nav-list {
      padding: 1.5rem 1rem;

      .logo {
        img {
          width: 120px;
        }
      }

      .btn {
        font-size: 12px;
        padding: 10px 10px;
      }

      .btn-group {
        .list {
          line-height: 0;
          padding-left: 0;

          & > * {
            padding: 0;

            &:first-child {
              padding-right: 1rem;
            }

            .btn {
              width: auto;
            }
          }
          .phone {
            i {
              font-size: 18px;
            }
            .phone-num {
              display: none;
            }
            .call-us {
              display: block;
              font-size: 12px;
              text-decoration: underline;
            }
          }
        }
      }
    }
  }
}
</style>
